import { Snackbar } from '@sparkpost/matchbox';

/**
 * Matchbox Snackbar component.
 * @see https://design.sparkpost.com/components/snackbar/
 */
const MatchboxSnackbar = Snackbar;

export default MatchboxSnackbar;
